<template>
    <div id="join-the-team">
        <navbar clickable="true"></navbar>
        <div id="sections-area">
            <job-hero></job-hero>
        </div>
        <img class="background-fixed-img" src="/img/startup-bg.jpg" alt="SPIRITT background">
    </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import Navbar from './components/Navbar.vue';
  import JobHero from './components/JobHero.vue';
  import FloatingImages from './components/FloatingImages.vue';

  export default {
    name: 'join-the-team',
    computed: {
      ...mapState('layout', {
        language: state => state.language,
      }),
      ...mapGetters({
        mobile: 'layout/mobile',
        modal: 'layout/modal',
        isScrolled: 'layout/isScrolled',
        isMvpModalOpen: 'layout/isMvpModalOpen',
      }),
    },
    components: {
      'navbar': Navbar,
      'job-hero': JobHero,
    },
    methods: {
      ...mapActions({
        updateModalTitle: 'layout/updateModalTitle',
        updateModalVisibility: 'layout/updateModalVisibility',
        updateModalContent: 'layout/updateModalContent',
        updateIsScrolled: 'layout/updateIsScrolled',
        updateMvpModalVisibility: 'layout/updateMvpModalVisibility',
      }),
      handleScroll () {
        return this.isScrolled && window.scrollY ? null : this.updateIsScrolled({
          payload: {
            scrolled: window.scrollY,
          },
        });
      },
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll);
    },
  }
</script>
<style lang="css" scoped>
    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap');
    #join-the-team {
        font-family: Josefin Sans, sans-serif;
        font-size: 1.125rem;
        position: relative;
        overflow: hidden;
        scroll-behavior: smooth;
        display: block;
    }
    .background-fixed-img{
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 1;
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        transition: opacity 1s;
        background-attachment: fixed;
        object-fit: cover;
        z-index: -1;
    }
    @media (max-width: 767px) and (min-width: 320px){
        .background-fixed-img {
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: 1;
            position: fixed;
            right: 0;
            top: 0;
            bottom: 0;
            transition: opacity 1s;
            z-index: -1;
        }
    }
</style>
